import { generatePassForEmployee } from './EmployeeService';

const PASSKIT_BASE_URL = 'https://pub1.pskt.io';

/**
 * Get PassKit URL for a given pass ID
 */
export const getPassKitUrl = (passId: string): string => {
  return `${PASSKIT_BASE_URL}/${passId}`;
};

/**
 * Open PassKit URL in a new window
 */
export const openPassKitUrl = (passId: string): void => {
  const url = getPassKitUrl(passId);
  window.open(url, '_blank', 'noopener, noreferrer');
};

/**
 * Handle adding pass to wallet
 * If pass is already issued, opens the existing pass URL
 * Otherwise, generates a new pass and opens it
 */
export const handleAddToWallet = async (
  employeeId: string,
  isPassIssued: boolean,
  passId: string | undefined,
  onPassGenerated?: () => Promise<void>
): Promise<void> => {
  if (!employeeId) {
    return;
  }

  // If pass is already issued and we have a passId, redirect to PassKit URL
  if (isPassIssued && passId) {
    openPassKitUrl(passId);
    return;
  }

  try {
    const response = await generatePassForEmployee(employeeId);
    const newPassId = response.record.pass_id;
    if (newPassId) {
      console.log('newPassId', newPassId);
      
      // Refresh employee data if callback provided
      if (onPassGenerated) {
        await onPassGenerated();
      }
      
      openPassKitUrl(newPassId);
    } else {
      throw new Error(`Failed to generate pass ${response.record.message}.`);
    }
  } catch (error) {
    console.error('Failed to generate pass:', error);
    throw new Error('Failed to generate pass. Please try again.');
  }
};
